<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.55215 2L9.81059 13.3157L1.5 22.5158H3.37038L10.6463 14.4609L16.525 22.5158H22.89L14.1669 10.5636L21.9023 2H20.032L13.3312 9.41835L7.91713 2H1.55215ZM4.30268 3.41183H7.22677L20.139 21.1037H17.215L4.30268 3.41183Z"
      fill="currentColor"
    />
  </svg>
</template>
